// Imagery — ONLY the real student/lab experiment photos provided by the client.
const B = "https://customer-assets-rejwkqb3.emergentagent.net/job_creator-stem-schools/artifacts/";
const A = {
  heroLab: `${B}yaxenvhb_Screenshot%202026-01-31%20153302.png`,       // teacher + 2 students, electrolysis/Pascal demo
  microscopes: `${B}yejkgzg8_Screenshot%202026-01-31%20154955.png`,
  girlsTrack: `${B}p65mvwul_Screenshot%202026-01-31%20153548.png`,
  boyTrack: `${B}obfejetx_Screenshot%202026-01-31%20150836.png`,
  fumehood: `${B}8z3l5rxz_Screenshot%202026-01-31%20155353.png`,
  oscilloscope: `${B}d101ugah_Screenshot%202026-01-31%20154926.png`,
  apparatus: `${B}kpnyx3tb_Screenshot%202026-01-31%20153618.png`,        // portrait
  pendulum: `${B}wqi8gn01_ikhbaa.jpg`,
  telescopeDemo: `${B}azhqx47j_a5.webp`,
  telescopeNight: `${B}wcpxftty_a1.webp`,
  blackboard: `${B}b8ikaiad_Screenshot%202026-01-31%20155411.png`,
  rotatingApp: `${B}xby25s6p_Screenshot%202026-01-31%20155446.png`,
  resonance: `${B}01jhr3yl_Screenshot%202026-01-31%20155428.png`,
  resonanceTube: `${B}1c95l3ye_Screenshot%202026-01-31%20155438.png`,
  youngModulus: `${B}n7s4bl8a_Screenshot%202026-01-31%20160158.png`,
  searles: `${B}nn8zciid_Screenshot%202026-01-31%20160143.png`,          // portrait
  scholars: `${B}2gix1al2_ikhbaa2.jpeg`,
};

export const IMG = {
  heroCampus: A.heroLab,
  lab1: A.girlsTrack,
  lab2: A.telescopeDemo,
  lab3: A.boyTrack,
  pblComponents: A.blackboard,
  shotA: A.resonance,
  shotB: A.oscilloscope,
  shotC: A.apparatus,
  campusWide: A.scholars,
  stem: {
    energy: A.fumehood,
    biotech: A.rotatingApp,
    ai: A.youngModulus,
    manufacturing: A.resonanceTube,
    space: A.telescopeDemo,
  },
  achievements: [
    { url: A.pendulum, label: "Measurement & Data" },
    { url: A.telescopeNight, label: "Astronomy · Observation" },
    { url: A.searles, label: "Elasticity · Young's Modulus" },
    { url: A.microscopes, label: "Biology · Microscopy" },
    { url: A.girlsTrack, label: "Physics · Motion Experiment" },
  ],
};

export const NAV = [
  { n: "01", label: "Vision", to: "/vision" },
  { n: "02", label: "Learning Redefined", to: "/learning-redefined" },
  { n: "03", label: "STEM", to: "/stem" },
  { n: "04", label: "PBL-TDLE", to: "/framework" },
  { n: "05", label: "Key Features", to: "/key-features" },
  { n: "06", label: "NTP", to: "/ntp" },
  { n: "07", label: "Outcomes", to: "/outcomes" },
  { n: "08", label: "Enroll", to: "/enroll" },
  { n: "09", label: "Tutor", to: "/become-a-tutor" },
  { n: "10", label: "Contact", to: "/contact" },
];

const ZC = "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=800,fit=crop/OyPMhZFo366K6YNr/";
export const ACHIEVEMENTS = [
  ZC + "noblitt-pnKbDunerXX13CJP.png",
  ZC + "kshitij-vF8PLP24JdH22Q3x.png",
  ZC + "bpho---new-AZxp2Vt2FUL5Cywt.png",
  ZC + "gold-medals-z7FDQ6GJdgYNAnYG.png",
  ZC + "ocla-9lTy7SzOfKS2T424.png",
  ZC + "nottingham-masira-CWSC0zMIlrg9Qo9X.png",
  ZC + "8-13-amc-zIj3hYZzvVJ9FKrx.png",
  ZC + "physcis-bowl-B5gbO2KzGCkUcqTw.png",
  ZC + "bioolympiad-ref71HQzqPotUDrh.png",
  ZC + "ap-award-5CHpMe6MOZLT2Mnb.png",
  ZC + "english-speaking-0kDWnBpWjB8a1QJp.png",
  ZC + "pbho-organizer-comments-RqhbVKzREi7Vdqr6.png",
  ZC + "ikhbaat-W989AStyJ3FpJIed.png",
  ZC + "3-100-in-2-yrs-04B1mUZg6j08sxdc.png",
  ZC + "vihaan-sFuDj9stjj33WxrH.png",
  ZC + "math-exam-of-america-nYzdtje8UDcLaXqB.jpeg",
  ZC + "ap-ikhbaat-3xEFduh51Za2NY2m.jpg",
  ZC + "rhit-ikhbaa-qLWQjOTXMtm62YZ3.jpg",
  ZC + "misa-OCvvLiubomqu0q8i.png",
  ZC + "ikhbaa2-GbiC5Em1XiNEHFoO.jpeg",
];
// Individual student posters used in Outcomes case-studies.
// URLs verified against thecreatoreducation.com/international-achievements.
export const STUDENT_POSTERS = {
  ikhbaat:  ZC + "ikhbaat-W989AStyJ3FpJIed.png",
  masira:   ZC + "nottingham-masira-CWSC0zMIlrg9Qo9X.png",
  kshitij:  ZC + "kshitij-vF8PLP24JdH22Q3x.png",
  vihaan:   ZC + "vihaan-sFuDj9stjj33WxrH.png",
};

export const COPE_MODULES = [
  { url: ZC + "co---cope-app-daCflFpO3kFB4lUx.png", t: "Concepts" },
  { url: ZC + "p---cope-app-BGz6HNWiTCJYVIkb.png", t: "Problems" },
  { url: ZC + "e---cope-app-BFo1AReWOskmvMQo.png", t: "Experiments" },
  { url: ZC + "app---cope-app-4f8JPGQnGSper6nQ.png", t: "Apparatus" },
];

export const MENU = [
  { label: "Home", to: "/" },
  {
    label: "Framework",
    to: "/framework",
    children: [
      { label: "The Vision & Philosophy", to: "/vision" },
      { label: "STEM Education", to: "/stem" },
      { label: "Learning Redefined", to: "/learning-redefined" },
      { label: "Concept Labs", to: "/concept-labs" },
      { label: "PBL-TDLE Framework", to: "/framework" },
      { label: "Key Features of Framework", to: "/key-features" },
    ],
  },
  {
    label: "Frontiers",
    to: "/ntp",
    children: [
      { label: "NTP Overview", to: "/ntp" },
      { label: "International Admissions", to: "/ntp#admissions" },
      { label: "International Competitions", to: "/ntp#competitions" },
      { label: "Advanced Problem-Solving Program", to: "/ntp#exams" },
      { label: "High School Research Program", to: "/research" },
    ],
  },
  {
    label: "Distinctions",
    to: "/outcomes",
    children: [
      { label: "Proven Outcomes", to: "/outcomes" },
      { label: "Student Achievements", to: "/outcomes#achievements" },
      { label: "Testimonials", to: "/outcomes#testimonials" },
    ],
  },
  {
    label: "Partners",
    to: "/enroll",
    children: [
      { label: "Why PBL-TDLE?", to: "/why-pbl-tdle" },
      { label: "Your Journey to PBL-TDLE", to: "/your-journey" },
      { label: "Our Partners", to: "/our-partners" },
      { label: "Enroll Your School", to: "/enroll" },
      { label: "Become a Tutor", to: "/become-a-tutor" },
    ],
  },
  {
    label: "About",
    to: "/about",
    children: [
      { label: "THECREATOR", to: "/thecreator" },
      { label: "THECREATOR Education", to: "/about" },
    ],
  },
];

export const FOUNDER = "https://customer-assets-rejwkqb3.emergentagent.net/job_creator-stem-schools/artifacts/dl6esk8z_image.png";

export const FOUNDER_VIDEO = {
  id: "7EGGzajg8Ys",
  title: "The Creator PBL-TDLE Teaching-Learning Model",
  author: "Mohammad Atiqur Rehman",
};

// Sourced from the founder's LinkedIn (linkedin.com/in/m-a-rehman-273220134)
// and the school-leadership page at the-creator.co.in/school-leadership.
export const FOUNDER_INFO = {
  name: "M. A. Rehman",
  title: "Founder & Chief Academic Architect · THECREATOR Education",
  credentials: "Astrophysicist · Department of Atomic Energy, Govt. of India · 25+ international research publications",
  bio: [
    "M. A. Rehman is a distinguished astrophysicist associated with the Department of Atomic Energy, Government of India, Mumbai. Over more than two decades of active scientific work he has contributed 25+ research publications in reputed international journals, spanning gamma-ray astrophysics, stellar evolution and the origin of the universe, nucleobase formation in space linked to the origin of life, and precise cross-section measurements for understanding radiation effects on DNA.",
    "Drawing on that research experience, he developed the PBL-TDLE framework — Problem-Based Learning through Teaching by Demonstrations and Learning by Experiments — a comprehensive teaching–learning architecture designed to ensure concept mastery through demonstrations, experiments, investigation and structured problem solving.",
    "He engineered the framework's 10,000+ open-ended problems, 1,500+ globally standardised apparatus and 5,000+ experiments himself, and proved it end-to-end at The Creator International School, transforming traditional classrooms into research-oriented Concept Labs. Today he leads THECREATOR Education's mission to bring the same research-lab discipline to K–12 schools everywhere — nurturing the next generation of problem solvers, innovators and researchers.",
  ],
};

// Press outlets — abbreviations shown on the home "In the News" strip.
export const PRESS = [
  { outlet: "KST",         headline: "How a school is rewriting STEM with Concept Labs",             href: "#" },
  { outlet: "Prashnkaal",  headline: "PBL-TDLE: when the classroom starts working like a research lab", href: "#" },
  { outlet: "Lokmat",      headline: "The innovator making problem solving the K–12 curriculum",     href: "#" },
  { outlet: "KhabrenShamtak",  headline: "CoPE-App: an AI academic engine built for concept mastery",    href: "#" },
  { outlet: "UT",          headline: "A decade of gold — inside India's most decorated olympiad cohort", href: "#" },
];

export const BROCHURE_URL = "/brochure.pdf";

export const OUTCOME_VIDEOS = [
  { id: "GYsPsX7CV8M", title: "Every student got a place in TOP world research universities" },
  { id: "G3NrO4hDWUU", title: "We prepared them for the TOP in the world and they got it" },
  { id: "gSZZcao1QpI", title: "100% 12th student got selected in top universities of the world" },
];

// Recognitions sourced from thecreatoreducation.com/international-achievements
// (poster OCR: BPhO organizer's remark, AMC 10/12, AP Scholar, PhysicsBowl, IO gold medals).
const ZP = "https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1200,fit=crop/OyPMhZFo366K6YNr/";
export const RECOGNITIONS = {
  bphoQuote: {
    src: ZP + "pbho-organizer-comments-RqhbVKzREi7Vdqr6.png",
    quote:
      "It is heartening to see that all participating students have received global awards, and we are incredibly proud of their achievements. This performance clearly reflects that your school's academic standards are at their peak, and we would be delighted to continue nurturing students by providing them with such global opportunities in the future.",
    attribution: "BPhO Organizer · British Physics Olympiad (JPC) 2026",
  },
  cards: [
    {
      key: "bpho",
      badge: "BPhO · JPC 2026",
      title: "British Physics Olympiad",
      headline: "All participating students awarded — global recognition, first attempt.",
      bullets: [
        "Every student who sat the paper received a BPhO global award",
        "Cited by the BPhO organizer as evidence of academic standards \"at their peak\"",
        "Built on the PBL-TDLE framework — teaching by demonstrations, learning by experiments",
      ],
      poster: ZP + "bpho---new-AZxp2Vt2FUL5Cywt.png",
    },
    {
      key: "ap",
      badge: "AP · College Board 2024",
      title: "AP Scholar Award",
      headline: "Exemplary college-level achievement — recognised globally.",
      bullets: [
        "NTP students recognised by the College Board with the AP® Scholar Award",
        "Awarded for scoring 3 or higher on three or more AP Exams",
        "Recognised by leading universities — carries college credit and advanced placement",
      ],
      poster: ZP + "ap-award-5CHpMe6MOZLT2Mnb.png",
    },
    {
      key: "amc",
      badge: "AMC 10 & 12 · First Year",
      title: "American Mathematics Competitions",
      headline: "8 out of 13 students earned the Outstanding Achievement Award — in the very first year of participation.",
      bullets: [
        "AMC is America's most prestigious and challenging school-mathematics competition",
        "First-year cohort: 8 of 13 students received the Outstanding Achievement Award",
        "Reflects strong conceptual foundations, analytical thinking and disciplined preparation",
      ],
      poster: ZP + "8-13-amc-zIj3hYZzvVJ9FKrx.png",
    },
    {
      key: "physicsbowl",
      badge: "PhysicsBowl 2026 · Bronze",
      title: "PhysicsBowl · Bronze Medal",
      headline: "Vihaan Deshmukh (Grade 9) — bronze at the international PhysicsBowl.",
      bullets: [
        "International recognition at Grade 9, competing across older cohorts",
        "Driven by curiosity and deep interest in Physics — nurtured inside the Concept Lab",
        "Part of the NextGen Training Program (NTP) mentorship pipeline",
      ],
      poster: ZP + "physcis-bowl-B5gbO2KzGCkUcqTw.png",
    },
    {
      key: "olympiad",
      badge: "SOF International Olympiads",
      title: "A Decade of Gold",
      headline: "1,500+ gold medals in 10 years · twice International Rank 1.",
      bullets: [
        "1,500+ gold medals across a decade — 150–200 every single year",
        "Two-time International Rank 1 across SOF's global Olympiads",
        "2025–26 season alone: 29 golds in IEO + 31 golds in IGKO",
      ],
      poster: ZP + "gold-medals-z7FDQ6GJdgYNAnYG.png",
    },
  ],
};

export const LOGO = "https://customer-assets-rejwkqb3.emergentagent.net/job_creator-stem-schools/artifacts/y7rx2r1y_Logo.png";

export const CONTACT = {
  email: "info@thecreatoreducation.com",
  phone: "+91-9869545863",
  socials: [
    { label: "Instagram", href: "https://instagram.com" },
    { label: "TikTok", href: "https://tiktok.com" },
    { label: "Twitter", href: "https://twitter.com" },
  ],
};

export const PULL_QUOTE =
  "A nation does not become developed by producing more degree holders. It becomes developed by producing more problem solvers, innovators, researchers, and entrepreneurs.";

export const BOARDS = ["CBSE", "ICSE", "State Board", "Cambridge (CAIE)", "Edexcel", "Oxford AQA", "IB", "Other"];
export const SIZES = ["Under 300", "Over 300", "300 – 800", "800 – 1500", "Over 1000", "1500 – 3000", "3000+"];
export const ROLES = ["Principal", "Vice Principal", "Academic Head", "Director", "Educator", "Management", "Trustee / Chairman", "Coordinator", "Teacher", "Other"];
export const SUBJECTS = ["Physics", "Chemistry", "Biology", "Mathematics", "Computer Science", "Research Mentoring", "Olympiad Coaching"];
export const EXAM_BADGES = ["AP", "NEET", "JEE", "BPhO", "AMC", "IPhO", "IChO", "IBO", "IMO", "SAT"];
